// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"454e0167","239":"57c93bbc","732":"aededa90"}[chunkId] + ".chunk.js";
};